import React from 'react';

import Jumbo from './Jumbo'
import Description from './Description';
import TweetStorm from './TweetStorm';
import DemoButton from './DemoButton';

const Home = ({ history }) => {

  history.listen((location, action) => {
      window.scrollTo(0, 0);
  });

  return (
    <>
      <Jumbo />
      <Description />
      <TweetStorm />
      <DemoButton />
    </>
  );
};

export default Home;